// Tiny on-device diagnostics ring buffer (localStorage) — page loads, JS errors, SW reloads.
// Attached to bug reports so PWA-only problems (e.g. black screens on iPhone) can be diagnosed remotely.
const KEY = 'olta-client-log';
const MAX = 40;

export function readClientLog() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
}

export function logClient(kind, data = {}) {
  try {
    const entries = readClientLog();
    entries.push({ t: new Date().toISOString(), kind, ...data });
    localStorage.setItem(KEY, JSON.stringify(entries.slice(-MAX)));
  } catch { /* storage full or blocked */ }
}

export function deviceInfo() {
  const nav = performance.getEntriesByType?.('navigation')?.[0];
  return {
    ua: (navigator.userAgent || '').slice(0, 160),
    standalone: !!window.navigator.standalone || window.matchMedia?.('(display-mode: standalone)')?.matches || false,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    nav_type: nav?.type || '',
    online: navigator.onLine,
    memory: navigator.deviceMemory || null,
    sw: !!navigator.serviceWorker?.controller,
  };
}

const short = (s) => String(s || '').replace(/\s+/g, ' ').slice(0, 400);

export function installClientLog() {
  if (window.__oltaClientLog) return;
  window.__oltaClientLog = true;
  const info = deviceInfo();
  const recent = readClientLog().filter(e => e.kind === 'load' && Date.now() - new Date(e.t).getTime() < 20000);
  logClient('load', { path: window.location.pathname, nav_type: info.nav_type, standalone: info.standalone, viewport: info.viewport, sw: info.sw });
  if (recent.length >= 2) logClient('reload_loop', { loads_20s: recent.length + 1 });
  window.addEventListener('error', (e) => {
    logClient('error', { msg: short(e.message), src: short(e.filename), line: e.lineno, stack: short(e.error?.stack) });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    logClient('rejection', { msg: short(r?.message || r), status: r?.response?.status, url: short(r?.config?.url) });
  });
  document.addEventListener('visibilitychange', () => logClient('visibility', { state: document.visibilityState }));
  window.addEventListener('pagehide', () => logClient('pagehide', {}));
  window.addEventListener('pageshow', (e) => { if (e.persisted) logClient('pageshow_bfcache', {}); });
}
